import { Component, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from "@/theme/ThemeComponent";
import { cart } from "@/theme/Cart";

@Component
export class CartBasket extends ThemeComponent {
    @Ref() itemCount!: HTMLSpanElement;

    private itemCounter: number = 0;

    /**
     * Initialise.
     */
    init() {
        document.addEventListener('cartAddedItem', () => {
            this.cartUpdated();
        });

        document.addEventListener('cartItemChange', () => {
            this.cartUpdated();
        });
    }

    cartUpdated() {
        this.itemCounter = 0;

        for (const item of cart.items) {
            this.itemCounter += item.quantity;
        }

        this.itemCount.innerHTML = `${this.itemCounter}`;
    }
}
